import gaTracker from "./gaTracking";
import ga4Tracker from "./ga4Tracking";
import frTracker from "./FRTracking";
import TrackingEvent from "../TrackingEvent.interface";

export default function sendAll(eventData: TrackingEvent) {
  [gaTracker, ga4Tracker, frTracker].forEach(tracker => {
    tracker.sendProviderEvent(eventData);
  });
}
